module.exports = __webpack_public_path__ + "img/reason11.7b9e2ead.jpg";